import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const useThemeDetector = () => {
  const $ = _c(4);
  const getCurrentTheme = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getCurrentTheme();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [isDarkTheme, setIsDarkTheme] = React.useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      setIsDarkTheme(e.matches);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const mqListener = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
      darkThemeMq.addEventListener("change", mqListener);
      return () => darkThemeMq.removeEventListener("change", mqListener);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  React.useEffect(t2, t3);
  return isDarkTheme ? "dark" : "light";
};
function _temp() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}